























import { Vue, Component, Watch } from 'vue-property-decorator'

export interface LangInterface {
  lang: string
  alt: string
  src: string
}

export interface CodeInterface {
  en: string
  es: string
  fr: string
}

@Component({})
export default class LanguageSwitcher extends Vue {
  private fab: boolean = false

  private dataAlt: CodeInterface = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
  }

  private dataSrc: CodeInterface = {
    en: require('~/assets/flags/us.png'),
    es: require('~/assets/flags/es.png'),
    fr: require('~/assets/flags/fr.png'),
  }

  private currentLang: LangInterface = { lang: '', alt: '', src: '' }
  private unselectedLang: Array<LangInterface> = []

  switchLanguage(lang: string): void {
    this.$i18n.locale = lang
    this.$vuetify.lang.current = lang
  }

  @Watch('$i18n.locale', { immediate: true, deep: true })
  onUrlChange(locale: string) {
    const list: Array<string> = ['fr', 'en', 'es']
    let src: string = ''
    let alt: string = ''
    this.unselectedLang = []
    list.forEach((lang) => {
      switch (lang) {
        case 'fr':
          src = this.dataSrc.fr
          alt = this.dataAlt.fr
          break
        case 'en':
          src = this.dataSrc.en
          alt = this.dataAlt.en
          break
        case 'es':
          src = this.dataSrc.es
          alt = this.dataAlt.es
          break
      }
      if (lang === locale) {
        this.currentLang = {
          lang,
          src,
          alt,
        }
      } else {
        this.unselectedLang.push({
          lang,
          src,
          alt,
        })
      }
    })
  }
}
